import { Injectable } from '@angular/core';
import {
  CalculationCreationOptions,
} from '../../../../../../../../common/src/options/calculations/calculation-creation.options';
import { FormFactory } from "@magieno/angular-advanced-forms";
import { AdvancedFormButton } from "@magieno/angular-advanced-forms";
import { ButtonStyleEnum } from '@magieno/angular-advanced-forms';
import { ButtonTypeEnum } from '@magieno/angular-advanced-forms';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {
  AdvancedForm as MagienoAdvancedForm,
  FormFactory as MagienoFormFactory,
  ButtonTypeEnum as MagienoButtonTypeEnum,
  ButtonStyleEnum as MagienoButtonStyleEnum,
} from '@magieno/angular-advanced-forms';


@Injectable()
export class CreateNewCalculationFormFactory {
  constructor(
    private readonly formFactory: FormFactory,
    private readonly magienoFormFactory: MagienoFormFactory,
  ) {

  }

  create(): AdvancedForm<CalculationCreationOptions> {
    return this.formFactory.create(new CalculationCreationOptions(), [
      new AdvancedFormButton('CREATE', ButtonStyleEnum.Primary, 'Créer le calcul', ButtonTypeEnum.Submit),
    ]);
  }

  createMagienoForm(): MagienoAdvancedForm<CalculationCreationOptions> {
    return this.magienoFormFactory.create(new CalculationCreationOptions(), [
      new AdvancedFormButton('CREATE', MagienoButtonStyleEnum.Primary, 'Créer le calcul', MagienoButtonTypeEnum.Submit),
    ]);
  }
}
